import { Card, Table } from "antd";
import React, { useEffect } from "react";
import Filterbox from "../../ui/FilterBox/Filterbox";
import BpsHeader from "../../ui/Header/Header";
import { eventsColumn } from "../../DummyAPI/TableData/Columns";
import ProgressLoader from "../../components/Loader/ProgressLoader";
import { useDispatch, useSelector } from "react-redux";
import { selectEventsData, selectEventsLoading } from './../../redux/selectors/eventSelectors';
import { listEvents } from './../../redux/actions/event';
import { formatDate } from "../../utils/utils";

const Events = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectEventsLoading);
  const eventList = useSelector(selectEventsData);

  const tableStyle = {
    tableLayout: "fixed",
  };

  // adding classname to odd table rows
  const rowClassName = (record, index) => {
    return index % 2 === 1 ? "odd-row" : "";
  };

  useEffect(() => {
    dispatch(listEvents());
  }, [dispatch]);

  const prepareDataToExport = () => {
    let data = eventList.map(item => {
      return {
        "Event Name": item?.name,
        "Description": item?.description,
        "Date": formatDate(item?.created_at)
      };
    });

    return data;
  };


  return (
    <ProgressLoader isLoading={isLoading}>
      <div className="events">
        <BpsHeader page={"Events"} />
        <Card className="events__container">
          <Filterbox 
            displayFilter={"none"}
            searchIsLoading={isLoading}
            searchAction={listEvents}
            showExportButton={false}
            showAddVendorButton={true}
          />
          <Table
            dataSource={eventList}
            columns={eventsColumn}
            pagination={false}
            rowClassName={rowClassName}
            style={tableStyle}
            scroll={{ x: 'max-content' }}
          />
        </Card>
      </div>
    </ProgressLoader>
  );
};

export default Events;